import React from 'react';

interface WindowHeaderProps {
  title: string;
  onClose: () => void;
}

const WindowHeader: React.FC<WindowHeaderProps> = ({ title, onClose }) => {
  return (
    <div className="window-header">
      <div className="window-title">{title}</div>
      <div className="window-buttons">
        <button
          className="window-button window-button-close"
          onClick={onClose}
          title="Fechar"
        >
          <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
            <path d="M 2,2 L 10,10 M 10,2 L 2,10" stroke="currentColor" strokeWidth="1.5"/>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default WindowHeader;
